import type { EditorIconName } from './editor-icons.tsx';
import type { KitMoreName } from './kit-more.tsx';

/**
 * The names of the icons that load after the shell (kit-more.tsx and editor-icons.tsx), kept
 * here as plain strings so code that checks a name needs none of their drawings. A test holds
 * this list to the two maps.
 */
export const LATER_ICON_NAMES = [
  'sliders',
  'clip',
  'layers',
  'shield',
  'palette',
  'database',
  'pulse',
  'message',
  'clock',
  'tag',
  'calendar',
  'target',
  'caps-lock',
  'user-x',
  'pointer',
  'building',
  'zap',
  'pull-request',
  'pull-request-draft',
  'pull-request-closed',
  'merged',
  'branch',
  'commit',
  'bookmark',
  'subtask',
  'smile',
  'bold',
  'italic',
  'checklist',
  'image',
  'at',
  'archive',
  'snooze',
  'bug',
  'undo',
  'upload',
  'print',
  'file-plus',
  'flag',
  'dot',
  'hexagon',
  'rocket',
  'map',
  'play',
  'cloud',
  'idea',
  'wrench',
  'megaphone',
  'shapes',
  'box',
  'grid',
  'globe',
  'heart',
  'flame',
  'puzzle',
  'text',
  'strike',
  'highlight',
  'heading',
  'subheading',
  'numbered',
  'quote',
  'divider',
  'callout',
  'outline',
  'decision',
  'page',
  'unlink',
  'row-add',
  'column-add',
  'header-row',
  'row-remove',
  'column-remove',
  'trash-can',
] as const satisfies ReadonlyArray<KitMoreName | EditorIconName>;
